import { Badge, Group } from '@mantine/core';
import type { Contact } from '../data/contactTypes';
import { resolveRoiStatus, type RoiStatus } from '../utils/contactRoiUtils';

const ROI_STATUS_COLOR: Record<RoiStatus, string> = {
  active: 'teal',
  expired: 'orange',
  pending: 'blue',
  none: 'gray',
};

const ROI_STATUS_LABEL: Record<RoiStatus, string> = {
  active: 'Active ROI',
  expired: 'Expired ROI',
  pending: 'Pending ROI',
  none: 'No ROI',
};

export interface ContactRoiBadgeProps {
  contact: Contact;
  onView: () => void;
}

export function ContactRoiBadge({ contact, onView }: ContactRoiBadgeProps): JSX.Element {
  const status = resolveRoiStatus(contact.roi);

  if (status === 'none') {
    return (
      <Badge variant="light" color={ROI_STATUS_COLOR.none} size="sm">
        {ROI_STATUS_LABEL.none}
      </Badge>
    );
  }

  return (
    <Group gap={4} wrap="nowrap" onClick={(e) => e.stopPropagation()}>
      <Badge
        variant="light"
        color={ROI_STATUS_COLOR[status]}
        size="sm"
        style={{ cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation();
          onView();
        }}
      >
        {ROI_STATUS_LABEL[status]}
      </Badge>
    </Group>
  );
}
